/**
 * Flow has NO sidebar. Founder, said again on 1 Oct 2026 after the firm's own
 * books showed one: "in Flow we will not give any sidebar ... close it once
 * and for all". First built as wv-7 (#1076, 7 Aug 2026); see
 * docs/FLOW_SCREEN_SPEC.md §1.0 and KARR_BIBLE.md.
 *
 * wv-7 exempted every practice org, to keep the office's rail (wv-2). That
 * exemption also handed the firm's OWN books, opened in Flow, the full Flow
 * nav as a sidebar (Home, Sales, Purchases, People & Products, Taxes,
 * Reports). The office's rail now has its own rule (`officeBooksRail`, the
 * office routes only), so the exemption is narrowed to exactly that:
 *
 * - Flow on any set of books, the firm's own included: no sidebar, no drawer,
 *   no hamburger. Home carries the map; every deeper screen keeps its hub
 *   strip and its Home breadcrumb.
 * - The office pages (/portfolio, /practice-crm, /requests, /partner,
 *   /my-work) are the practice altitude, not a set of books, and keep their
 *   one-word "Books" rail.
 * - Books keeps the full sidebar.
 */
export function flowHidesSidebar(o: { isFlow: boolean; isPracticeOrg: boolean; practiceMode: boolean }): boolean {
    if (!o.isFlow) return false;
    return !(o.isPracticeOrg && o.practiceMode);
}
